<div class="sidebar">
  <p-menu [model]="items" class="sidebar-menu"></p-menu>
</div>
